/* ==============================================
   WISHLIST - Boutique Nuance
   Liste de favoris avec localStorage
   ============================================== */

class Wishlist {
  constructor() {
    this.storageKey = 'nuance_wishlist';
    this.items = this.getItems();
    this.init();
  }

  init() {
    this.bindEvents();
    this.updateAllButtons();
    this.updateCounter();
  }

  getItems() {
    try {
      const items = localStorage.getItem(this.storageKey);
      return items ? JSON.parse(items) : [];
    } catch (e) {
      return [];
    }
  }

  saveItems() {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(this.items));
    } catch (e) {
      console.error('Wishlist save error:', e);
    }
  }

  addItem(productId, productData) {
    if (!this.hasItem(productId)) {
      this.items.push({
        id: productId,
        handle: productData.handle || '',
        title: productData.title || '',
        price: productData.price || '',
        image: productData.image || '',
        url: productData.url || '',
        addedAt: Date.now()
      });
      this.saveItems();
      this.updateCounter();
      return true;
    }
    return false;
  }

  removeItem(productId) {
    const index = this.items.findIndex(item => item.id === productId);
    if (index > -1) {
      this.items.splice(index, 1);
      this.saveItems();
      this.updateCounter();
      return true;
    }
    return false;
  }

  toggleItem(productId, productData) {
    if (this.hasItem(productId)) {
      this.removeItem(productId);
      return false;
    } else {
      this.addItem(productId, productData);
      return true;
    }
  }

  hasItem(productId) {
    return this.items.some(item => item.id === productId);
  }

  getCount() {
    return this.items.length;
  }

  clear() {
    this.items = [];
    this.saveItems();
    this.updateCounter();
  }

  bindEvents() {
    document.addEventListener('click', (e) => {
      const wishlistBtn = e.target.closest('.wishlist-btn');
      if (wishlistBtn) {
        e.preventDefault();
        e.stopPropagation();
        this.handleButtonClick(wishlistBtn);
      }
    });
  }

  handleButtonClick(button) {
    const productId = button.dataset.productId;
    const productData = {
      handle: button.dataset.productHandle || '',
      title: button.dataset.productTitle || '',
      price: button.dataset.productPrice || '',
      image: button.dataset.productImage || '',
      url: button.dataset.productUrl || ''
    };

    const isNowInWishlist = this.toggleItem(productId, productData);

    // Update button state
    button.classList.toggle('is-active', isNowInWishlist);
    button.setAttribute('aria-pressed', isNowInWishlist);

    // Animation feedback
    button.classList.add('wishlist-btn--animating');
    setTimeout(() => {
      button.classList.remove('wishlist-btn--animating');
    }, 300);

    // Update all buttons with same product ID
    this.updateButtonsForProduct(productId, isNowInWishlist);

    // Dispatch custom event
    document.dispatchEvent(new CustomEvent('wishlist:changed', {
      detail: { productId, isInWishlist: isNowInWishlist, count: this.getCount() }
    }));
  }

  updateButtonsForProduct(productId, isActive) {
    document.querySelectorAll(`.wishlist-btn[data-product-id="${productId}"]`).forEach(btn => {
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive);
    });
  }

  updateAllButtons() {
    document.querySelectorAll('.wishlist-btn').forEach(btn => {
      const productId = btn.dataset.productId;
      const isInWishlist = this.hasItem(productId);
      btn.classList.toggle('is-active', isInWishlist);
      btn.setAttribute('aria-pressed', isInWishlist);
    });
  }

  updateCounter() {
    const count = this.getCount();
    document.querySelectorAll('.wishlist-count').forEach(counter => {
      counter.textContent = count;
      counter.classList.toggle('hidden', count === 0);
    });
    document.querySelectorAll('.wishlist-counter-bubble').forEach(bubble => {
      bubble.classList.toggle('hidden', count === 0);
    });
  }
}

// Initialize wishlist
window.wishlist = new Wishlist();

// Render wishlist page items
function renderWishlistPage() {
  const container = document.querySelector('.wishlist-items-container');
  if (!container) return;

  const items = window.wishlist.items;
  const emptyMessage = document.querySelector('.wishlist-empty');

  if (items.length === 0) {
    container.innerHTML = '';
    if (emptyMessage) emptyMessage.style.display = 'block';
    return;
  }

  if (emptyMessage) emptyMessage.style.display = 'none';

  container.innerHTML = items.map(item => `
    <div class="wishlist-item" data-product-id="${item.id}">
      <a href="${item.url}" class="wishlist-item__image">
        <img src="${item.image}" alt="${item.title}" loading="lazy">
      </a>
      <div class="wishlist-item__info">
        <a href="${item.url}" class="wishlist-item__title">${item.title}</a>
        <p class="wishlist-item__price">${item.price}</p>
      </div>
      <button type="button" class="wishlist-item__remove" data-product-id="${item.id}" aria-label="Retirer des favoris">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
  `).join('');

  // Bind remove buttons
  container.querySelectorAll('.wishlist-item__remove').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const productId = e.currentTarget.dataset.productId;
      window.wishlist.removeItem(productId);
      renderWishlistPage();
      window.wishlist.updateAllButtons();
    });
  });
}

// Listen for wishlist changes
document.addEventListener('wishlist:changed', renderWishlistPage);

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  renderWishlistPage();
  window.wishlist.updateAllButtons();
});
